import styled from 'styled-components'

export const ConversationOrderSummaryDividerStyled = styled.div`
  padding: 0
    ${(props) =>
      props.theme.box.horizontalPadding(props.theme.typography.htmlFontSize)};
`
